import React from 'react';
import { MdLocalShipping, MdAccountBalanceWallet, MdLibraryAddCheck } from 'react-icons/md';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

const CheckoutSteps = ({ activeStep }) => {
    const steps = [
        {
            label: 'Shipping Details',
            icon: <MdLocalShipping />,
        },
        {
            label: 'Confirm Order',
            icon: <MdLibraryAddCheck />,
        },
        {
            label: 'Payment',
            icon: <MdAccountBalanceWallet />,
        },
    ];

    const stepStyles = {};

    return (
        <>
            <Stepper alternativeLabel activeStep={activeStep} style={stepStyles}>
                {steps.map((step, i) => (
                    <Step
                        key={i}
                        active={activeStep === i ? true : false}
                        completed={activeStep >= i ? true : false}
                    >
                        <StepLabel
                            style={{ color: activeStep === i ? '#6200ea' : 'rgba(0,0,0,.649)' }}
                            icon={step.icon}
                        >
                            {step.label}
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </>
    );
};

export default CheckoutSteps;
